import { createAction } from 'redux-act';

import PlaceLayouts from '../../../models/interfaces/layout/PlaceLayouts';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchPlaceLayoutsPayload extends FetchPayload {
  placeUuid: string;
}
export const fetchPlaceLayouts = createAction<FetchPlaceLayoutsPayload>('FETCH_PLACE_LAYOUTS');
export interface PlaceLayoutsFetchedPayload extends TimestampPayload {
  placeLayouts: PlaceLayouts;
}
export const placeLayoutsFetched = createAction<PlaceLayoutsFetchedPayload>('PLACE_LAYOUTS_FETCHED');
export interface PlaceLayoutsFetchFailedPayload extends TimestampPayload {
  placeUuid: string;
}
export const placeLayoutsFetchFailed = createAction<PlaceLayoutsFetchFailedPayload>('PLACE_LAYOUTS_FETCH_FAILED');
